export function getAntialiasedSizePx(targetSizePx: number): number {
  const { devicePixelRatio } = window;

  return Math.round(targetSizePx * devicePixelRatio) / devicePixelRatio;
}

export function getMinAntialiasedSizePx(): number {
  const { devicePixelRatio } = window;

  return 1 / devicePixelRatio;
}
